import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { forkJoin, Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { MenuService } from './services/menu.service';
import { Constant } from './constant/constant';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class InitialDataResolver implements Resolve<any>
{
    categoryList: any;
    /**
     * Constructor
     *
     * @param {HttpClient} httpClient
     */
    constructor(
        private httpClient: HttpClient,
        private menuService: MenuService,
    )
    {
    }



    /**
     * Load navigation data
     *
     * @private
     */
    private _loadNavigation()
    {

        return this.httpClient.get<any>(
            `${environment.serverAPI}/api/menu`).pipe(
            map(
              data => {
                if (data == '' || data == undefined || data == null) {
                this.categoryList=data;
                } 
                else {      
                  return data;
                }
      
              }
            ),
            catchError((err) => {
              // 401 / token expired — signal resolver to redirect
              return throwError(err);
            })
          );
    }



    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Resolver
     *
     * @param route
     * @param state
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>
    {
        return forkJoin([

            // Navigation data
            this._loadNavigation(),

        ]).pipe(
            map((data) => {

                return {
                    navigation   : {
                        compact   : data,
                        default   : data,
                        futuristic: data,
                        horizontal: data
                    },
                
                };
            }),
            catchError((err) => {
                // Token expired or 401 — clear storage and redirect to login immediately.
                // Using window.location.href ensures this works even before the Angular
                // router has fully initialised (resolver phase).
                localStorage.clear();
                sessionStorage.clear();
                document.cookie = 'cxi=;expires=' + new Date(0).toUTCString() + ';path=/';
                document.cookie = 'cci=;expires=' + new Date(0).toUTCString() + ';path=/';
                document.cookie = 'user-name=;expires=' + new Date(0).toUTCString() + ';path=/';
                window.location.href = '/sign-in';
                return of(null);
            })
        );
    }
}
